// extracted by mini-css-extract-plugin
export default {"container":"carousel_container__3a6l0","items":"carousel_items__3dGiK"};